module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0e370ab3cadb27d9b1271cb732ec5fc5.png";